webpackJsonp([2845203110960],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/shop-merino-classic-scarf.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"path": "/shop/merino-classic-scarf/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---shop-merino-classic-scarf-83a56b2992d95d4ebae5.js